import styled from 'styled-components';
import { Divider as AntdDivider } from 'antd';

const Divider = styled(AntdDivider)`
  margin: ${({margin}) => margin ? `${margin} 0` : '24px 0'};
`;

export default Divider;